import { useEffect, useRef } from "react";
import { useSession } from "#/lib/useSession";
import { getMyUnlockedSlugs } from "#/server/functions/privateProducts";
import { useUnlockStore } from "#/store/unlock";

export function useUnlockSync(): void {
  const { customer } = useSession();
  const customerId = customer?.id ?? null;
  const applyRedeem = useUnlockStore((s) => s.applyRedeem);
  const lastHydratedFor = useRef<string | null>(null);

  useEffect(() => {
    if (!customerId) {
      lastHydratedFor.current = null;
      return;
    }
    if (lastHydratedFor.current === customerId) return;
    lastHydratedFor.current = customerId;
    let cancelled = false;
    void getMyUnlockedSlugs().then((result) => {
      if (cancelled) return;
      if (!result.ok) return;
      if (result.data.unlockedSlugs.length === 0) return;
      applyRedeem({
        unlockedSlugs: result.data.unlockedSlugs,
        token: result.data.token,
        expiresInSeconds: result.data.expiresInSeconds,
      });
    });
    return () => {
      cancelled = true;
    };
  }, [customerId, applyRedeem]);
}

export function UnlockSync(): null {
  useUnlockSync();
  return null;
}
